import Vue from 'vue';
import Router from 'vue-router';
// Containers
import DefaultContainer from '../containers/DefaultContainer';
// Views
import Home from '../components/Home/Home';
import VideoTutorials from '../components/Home/VideoTutorials';
import NotificationPage from '../components/NotificationPage';

import Dashboard from '../components/Dashboard';
import FileDashboard from '../components/FileDashboard';
import Dashboards from '../components/Dashboards';
import HistoricalDashboards from '../components/HistoricalDashboards';
import StaticDashboard from '../components/StaticDashboard';
import ExternalAnalytics from '../components/ExternalAnalytics';

import Lists from '../components/Lists';
import ListDashboard from '../components/Lists/Dashboard';
import ListView from '../components/Lists/View';

import Segments from '../components/Segments/Segments';
import SegmentDashboard from '../components/Segments/Dashboard';
import SegmentInsights from '../components/Segments/SegmentInsights';

import Files from '../components/Sources/Files';
import Sources from '../components/Sources';
import SourcesV2 from '../components/Sources';
import ReferralProgram from '../components/Referrals/ReferralProgram';
import Plans from '../components/Plans';
import SidebarTo360 from '../components/Customer360/SidebarTo360';
import Customer360 from '../components/Customer360';
import View360 from '../components/Customer360/View360';

import CustomReportsManager from '../components/CustomReportsManager';
import ExternalAnalyticsManager from '../components/ExternalAnalyticsManager';
import ReportSummary from '../components/CustomReportsManager/ReportSummary';

import VueAnalytics from 'vue-ua';


Vue.use(Router);

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/__custom_reports__",
      name: "Custom Reports Manager",
      component: CustomReportsManager
    },
    {
      path: "/__external_analytics__",
      name: "External Analytics Manager",
      component: ExternalAnalyticsManager
    },
    {
      path: "/__external_analytics__",
      name: "External Analytics Manager",
      component: ExternalAnalyticsManager
    },
    {
      path: '/',
      // redirect: '/sources',
      // name: 'Sources',
      name: 'Home',

      component: DefaultContainer,
      // component: Plans,

      children: [
	      {
          path: '/',
          name: 'Home',
          component: Home,
        },
	      {
          path: '/help/videos',
          name: 'Video Tutorials',
          component: VideoTutorials,
        },
        {
          path: '/dashboard/database/:id?',
          name: 'Database Dashboard',
          component: Dashboard,
        },
        {
          path: '/dashboard/:id?',
          name: 'Dashboard',
          component: FileDashboard,
          // component: Dashboard,
        },
        // {
        //   path: '/dashboard',
        //   redirect: '/sources'
        // },
        {
          path: '/historical-dashboards',
          redirect: '/historical-reports',
          name: 'Historical Dashboards',
          component: HistoricalDashboards,
        },
        {
          path: '/business-insights',
          name: 'Business Insights',
          component: Dashboards,
        },
        {
          path: '/standard-insights',
          name: 'Standard Insights',
          component: Dashboards,
        },
        {
          path: '/customer-insights',
          name: 'Customer Insights',
          component: Dashboards,
        },
        {
          path: '/historical-reports',
          name: 'Historical Dashboards',
          component: HistoricalDashboards,
        },
        {
          path: '/custom-reports',
          name: "Custom Reports",
          component: StaticDashboard,
          meta: {
            beta: 1,
          }
        },
        {
          path: '/external-analytics',
          name: "API Analytics",
          component: ExternalAnalytics,
        },
        {
          path: '/segments',
          name: 'Segments',
          component: SegmentDashboard
        },
        {
          path: '/segments/:projectID?/:meta?/:id?',
          name: 'Segment Insights',
          component: SegmentInsights
        },
        {
          path: 'lists',
          redirect: '/lists/dashboard',
          name: 'Lists',
          component: Lists,
          children: [
		    {
              path: 'dashboard',
              component: ListDashboard,
            },
            {
              path: ':id',
              name: 'Customer List',
              component: ListView,
            }
          ]
        },
        {
          path: '/sources',
          name: 'SourcesV2',
          component: SourcesV2
        },
        {
          path: '/sources/files',
          name: 'Files',
          component: Files
        },
        {
          path: '/monitor',
          name: 'NotificationPage',
          component: NotificationPage
        },
        {
          path: '/plans',
          name: 'Plans',
          component: Plans
        },
        {
          path: '/referral',
          name: 'Referral Program',
          component: ReferralProgram
        },
        {
          path: '/360',
          name: '360 view',
          component: SidebarTo360
        },
        {
          path: '/360/:database/:collection/:id?',
          name: 'Customer 360 view',
          component: Customer360,
          meta: {
            beta: 0,
          }
        },
        {
          path: '/custom-reports/agent-report/summary/:id?',
          name: 'Agent Report Summary',
          component: ReportSummary,
          meta: {
            beta: 0,
          }
        },
        {
          path: '/view/:id',
          name: '360 Detail',
          component: View360
        }
      ],
    },
  ],
});

Vue.use(VueAnalytics, {
  // [Required] The name of your app as specified in Google Analytics.
  appName: 'SuperScore',
  // [Required] The version of your app.
  appVersion: '1',
  // [Required] Your Google Analytics tracking ID.
  trackingId: 'UA-140910011-2',
  // If you're using vue-router, pass the router instance here.
  vueRouter: router,

  // Global Dimensions and Metrics can optionally be specified.
  globalDimensions: [
    { dimension: 1, value: 'FirstDimension' },
    { dimension: 2, value: 'SecondDimension' }
    // Because websites are only 2D, obviously. WebGL? What's that?
  ],

  globalMetrics: [
    { metric: 1, value: 'MyMetricValue' },
    { metric: 2, value: 'AnotherMetricValue' }
  ]
})

export default router;